import { render, staticRenderFns } from "./goodsCatSaleStat.vue?vue&type=template&id=61e6c891&"
import script from "./goodsCatSaleStat.vue?vue&type=script&lang=js&"
export * from "./goodsCatSaleStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports